/* RESPONSIBLE TEAM: team-ai-agent */
import { helper } from '@ember/component/helper';
import generateUUID from 'embercom/lib/uuid-generator';

export interface Signature {
  Args: {
    Positional: [string];
  };
  Return: string;
}

export function generateSortableGroupName([baseGroupName]: Signature['Args']['Positional']) {
  let uuid = generateUUID();
  return `${baseGroupName}-${uuid}`;
}

const generateSortableGroupNameHelper = helper<Signature>(generateSortableGroupName);

export default generateSortableGroupNameHelper;
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'generate-sortable-group-name': typeof generateSortableGroupNameHelper;
  }
}
